__webpack_require__.p = "__VAN_STATIC_BASE_PATH__/";